import api from './api'

export default class PutRequest {
  url: string

  body: any
  headers: any
  timeout: number | undefined

  constructor(url: string, body: any, headers?: Record<string, string>, timeout?: number) {
    this.url = url
    this.headers = headers
    this.body = body
    this.timeout = timeout
  }

  async run<R>() {
    return api.put<R>(this.url, this.body, { headers: this.headers, timeout: this.timeout })
  }
}
